module.exports = __webpack_public_path__ + "img/graph-green.f5bc4a68.webp";